<template>
    <div class="status">
        <slot/>
    </div>
</template>

<style lang="scss">
    .status {
        margin: 1rem 0;
        text-align: center;
        font-size: 1rem;
        font-weight: bold;
        font-style: italic;
        padding-left: 1rem;
        padding-right: 1rem;
    }
    .status-small {
        margin: .5rem 0;
        text-align: center;
        font-size: 1.5rem;
        font-weight: bold;
        font-style: italic;
        padding-left: .5rem;
        padding-right: .5rem;
    }
    .status-smallest {
        margin: .3rem 0;
        text-align: center;
        font-size: 1rem;
        font-weight: bold;
        font-style: italic;
        padding-left: .2rem;
        padding-right: .2rem;
    }
</style>

<script lang="ts">

import { defineComponent } from "vue";

export default defineComponent({
    name: "HeaderMessage"
});

</script>
